export type BrandingEntry = {
  productId: string
  statuses?: number[]
  cinematicsTag: string
}

/**
 * Maps appCode → ordered list of branding entries (first match wins).
 * This is a temporary client-owned mapping until the backend exposes
 * a branding eligibility endpoint.
 */
export const BRANDING_MAP: Record<string, BrandingEntry[]> = {
  liga1play: [
    { productId: '678e97ccc14c9645286a6cd2', cinematicsTag: 'liga1ProdIntimo' }, // <-- Intimo L1MAX
  ],
}
